import React from 'react';
import styled from 'styled-components';
import { adminTheme } from '../../theme-admin';

const Card = styled.div`
  position: relative;
  background: ${props => props.$gradient || adminTheme.gradients.primary};
  border-radius: ${adminTheme.borderRadius['2xl']};
  padding: ${adminTheme.spacing.xl};
  color: white;
  overflow: hidden;
  box-shadow: ${adminTheme.shadows.lg};
  transition: ${adminTheme.transitions.normal};
  animation: slideUp 0.5s ease-out;
  animation-delay: ${props => props.$delay || '0s'};
  animation-fill-mode: both;

  &:hover {
    transform: translateY(-4px);
    box-shadow: ${adminTheme.shadows['2xl']};
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 150px;
    height: 150px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    transform: translate(30%, -30%);
  }
`;

const IconWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: ${adminTheme.borderRadius.xl};
  font-size: ${adminTheme.fontSizes['3xl']};
  margin-bottom: ${adminTheme.spacing.md};
  box-shadow: ${adminTheme.shadows.md};
`;

const Title = styled.h3`
  font-family: ${adminTheme.fonts.heading};
  font-size: ${adminTheme.fontSizes.sm};
  font-weight: ${adminTheme.fontWeights.semibold};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 ${adminTheme.spacing.sm};
  opacity: 0.9;
`;

const Value = styled.div`
  font-family: ${adminTheme.fonts.heading};
  font-size: ${adminTheme.fontSizes['4xl']};
  font-weight: ${adminTheme.fontWeights.bold};
  margin: 0 0 ${adminTheme.spacing.xs};
  line-height: 1;
`;

const Subtitle = styled.div`
  font-size: ${adminTheme.fontSizes.sm};
  opacity: 0.85;
  display: flex;
  align-items: center;
  gap: ${adminTheme.spacing.xs};
`;

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: ${adminTheme.borderRadius.full};
  font-size: ${adminTheme.fontSizes.xs};
  font-weight: ${adminTheme.fontWeights.semibold};
`;

export default function StatCard({ 
  icon, 
  title, 
  value, 
  subtitle, 
  trend, 
  gradient,
  delay 
}) {
  return (
    <Card $gradient={gradient} $delay={delay}>
      <IconWrapper>{icon}</IconWrapper>
      <Title>{title}</Title>
      <Value>{value}</Value>
      {(subtitle || trend) && (
        <Subtitle>
          {subtitle}
          {trend && (
            <Badge>
              {trend > 0 ? '↑' : '↓'} {Math.abs(trend)}%
            </Badge>
          )}
        </Subtitle>
      )}
    </Card>
  );
}
